import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { CheckCircle, XCircle, FileText, User, Building, CreditCard } from 'lucide-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import { Base_Url, userlist, userdocApprove, Url_For_View_Document, deleteuser } from '../../config/config';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useAuth } from '../../routes/Auth';
import { FaEye } from 'react-icons/fa'
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ViewAllCustomerModel from '../../component/b2c/models/ViewAllCustomerModel'

const KYCPending = () => {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const { isToggleSidebar, isDarkMode,setIsToggleSidebar } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryByName, SearchQueryByName] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [selectedApproval, setSelectedApproval] = useState({});
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCustomers, setTotalCustomers] = useState();
  const [limit, setLimit] = useState(10);
  const role = localStorage.getItem('role');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [originalTotalCustomers, setOriginalTotalCustomers] = useState(0);

  const navigate = useNavigate();

  const goTobankReq = () => {
    navigate("/allReqForBankdoc")
  }
  useEffect(() => {
    getDocumentList();
  }, [currentPage, limit]);


  const getDocumentList = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;
        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal)
        setOriginalTotalCustomers(adjustedTotal);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handlePaginationChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setCurrentPage(1);
  };

  const handleRadioChange = (customerId, documentType, status) => {
    setSelectedApproval((prev) => ({
      ...prev,
      [customerId]: {
        ...prev[customerId],
        [documentType]: status
      }
    }));
  };

  const hasAnyRadioSelection = (customer) => {
    const customerSelections = selectedApproval[customer.id] || {};

    const hasPendingAadhar = customer.user_address_image && customer.aadhar_status === "0";
    const hasPendingPan = customer.user_pancard_image && customer.pan_card_status === "0";
    const hasPendingGst = customer.user_gst_image && customer.gst_status === "0";

    const hasAadharSelection = hasPendingAadhar && customerSelections.address;
    const hasPanSelection = hasPendingPan && customerSelections.pancard;
    const hasGstSelection = hasPendingGst && customerSelections.gstin;

    return hasAadharSelection || hasPanSelection || hasGstSelection;
  };

  const shouldShowSubmitButton = (customer) => {
    const allApproved =
      customer.aadhar_status === "1" &&
      customer.pan_card_status === "1" &&
      customer.gst_status === "1";

    const allRejected =
      customer.aadhar_status === "2" &&
      customer.pan_card_status === "2" &&
      customer.gst_status === "2";

    const noDocuments =
      !customer.user_address_image &&
      !customer.user_pancard_image &&
      !customer.user_gst_image;

    return !allApproved && !allRejected && !noDocuments && hasAnyRadioSelection(customer);
  };

  const handleSubmit = async (customerId) => {
    const customer = customers.find(c => c.id === customerId);
    const hasAadharDoc = customer?.user_address_image;
    const hasPanDoc = customer?.user_pancard_image;
    const hasGstDoc = customer?.user_gst_image;
    const aadharStatus = customer?.aadhar_status;
    const panStatus = customer?.pan_card_status;
    const gstStatus = customer?.gst_status;

    const selectedAadhar = selectedApproval[customerId]?.address;
    const selectedPan = selectedApproval[customerId]?.pancard;
    const selectedGst = selectedApproval[customerId]?.gstin;

    const missingSelections = [];

    if (hasAadharDoc && aadharStatus !== "1" && !selectedAadhar) {
      missingSelections.push("Aadhaar");
    }
    if (hasPanDoc && panStatus !== "1" && !selectedPan) {
      missingSelections.push("PAN Card");
    }
    if (hasGstDoc && gstStatus !== "1" && !selectedGst) {
      missingSelections.push("GSTIN");
    }
    if (missingSelections.length > 0) {
      toast.error(
        `Please select approval or reject status for: ${missingSelections.join(", ")}`
      );
      return;
    }
    try {
      setLoading((prev) => ({ ...prev, [customerId]: true }));
      const approvalData = {
        customer_id: customerId,
        aadhar_status: aadharStatus === "1" ? "1" : selectedApproval[customerId]?.address,
        pancard_status: panStatus === "1" ? "1" : selectedApproval[customerId]?.pancard,
        gst_status: gstStatus === "1" ? "1" : selectedApproval[customerId]?.gstin,
      };

      const response = await axios.post(
        `${Base_Url}admin/${userdocApprove}`,
        approvalData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        toast.success("Documents Updated Successfully!");
        getDocumentList();
      } else {
        toast.error(`Error: ${response.data.message}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoading((prev) => ({ ...prev, [customerId]: false }));
    }
  };
  const handleDocumentClick = (url) => {
    if (!isAuthenticated) {
      window.location.href = '/dashboard';
    } else {
      window.open(url, '_blank');
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    if (!/^\d{0,12}$/.test(value)) {
      return;
    }
    setSearchQuery(value);
    setCurrentPage(1);
    if (value.length === 12) {
      const filtered = customers.filter((customer) =>
        customer.aadhar_number?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCustomers(filtered);
      setTotalCustomers(filtered.length);
    } else if (value === "") {
      setFilteredCustomers([]);
      setTotalCustomers(originalTotalCustomers);
    }
  };


  useEffect(() => {
    let filtered = customers;

    if (searchQuery.trim() !== '') {
      filtered = filtered.filter(customer =>
        customer.aadhar_number?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (searchQueryByName.trim() !== '') {
      filtered = filtered.filter(customer =>
        customer.name?.toLowerCase().includes(searchQueryByName.toLowerCase())
      );
    }

    setFilteredCustomers(filtered);
  }, [searchQuery, searchQueryByName, customers]);


  const handleSearchChangeByName = (event) => {
    const value = event.target.value;
    SearchQueryByName(value);
    setCurrentPage(1);

    if (value.length > 0) {
      const filtered = customers.filter((customer) =>
        customer.name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCustomers(filtered);
      setTotalCustomers(filtered.length);
    } else if (value === "") {
      setFilteredCustomers([]);
      setTotalCustomers(originalTotalCustomers);
    }
  };
  const handleClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDelete = async (customer) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: customer.id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            getDocumentList();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };

  const docStatusBlock = (status, customerId, field) => {
    if (status === "1") {
      return (
        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-semibold border ${isDarkMode
            ? 'bg-emerald-500/10 text-emerald-300 border-emerald-500/40 shadow-[0_0_8px_rgba(16,185,129,0.2)]'
            : 'bg-green-50 text-green-700 border-green-200'
          }`}>
          <CheckCircle className="w-3 h-3" /> Approved
        </span>
      );
    }
    if (status === "2") {
      return (
        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-semibold border ${isDarkMode
            ? 'bg-rose-500/10 text-rose-300 border-rose-500/40 line-through'
            : 'bg-red-50 text-red-500 border-red-200'
          }`}>
          <XCircle className="w-3 h-3" /> Rejected
        </span>
      );
    }
    return (
      <div className="flex items-center gap-1.5 text-[9px] flex-wrap">
        <label className="flex items-center gap-0.5 cursor-pointer">
          <input
            type="radio"
            name={`approval-${customerId}-${field}`}
            value="1"
            checked={selectedApproval[customerId]?.[field] === "1"}
            onChange={() => handleRadioChange(customerId, field, "1")}
            className={`w-3 h-3 ${isDarkMode ? 'accent-emerald-500' : 'accent-black'}`}
          />
          Approve
        </label>
        <label className="flex items-center gap-0.5 cursor-pointer">
          <input
            type="radio"
            name={`approval-${customerId}-${field}`}
            value="2"
            checked={selectedApproval[customerId]?.[field] === "2"}
            onChange={() => handleRadioChange(customerId, field, "2")}
            className={`w-3 h-3 ${isDarkMode ? 'accent-rose-500' : 'accent-black'}`}
          />
          Reject
        </label>
      </div>
    );
  };

  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'}`}>
      {isDarkMode ? (
        <>
          <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
          <div className="pointer-events-none absolute top-1/2 -right-40 h-[400px] w-[400px] rounded-full bg-emerald-600/10 blur-[100px]" />
        </>
      ) : (
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl" />
      )}

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
            {isToggleSidebar && (
                        <div
                            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                            onClick={() => setIsToggleSidebar(false)}
                        />
                    )}

                    <div
                        className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                    >
                        <Sidebar />
                    </div>
        <div className={`flex-1 p-2.5 sm:p-3 md:p-4 w-full overflow-hidden flex flex-col transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-100'}`}>
          <div className="max-w-7xl mx-auto w-full flex flex-col h-full">

            {/* Header - Fixed */}
            <div className="flex-shrink-0">
              <div className="flex items-center gap-2 mb-3">
                <div className={`p-2 rounded-lg border transition-all duration-300 flex-shrink-0 ${isDarkMode
                    ? 'bg-gradient-to-br from-indigo-500/20 to-purple-500/10 border-indigo-500/30 shadow-[0_0_15px_rgba(99,102,241,0.2)]'
                    : 'border-gray-300'
                  }`}>
                  <FileText size={14} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                </div>
                <div className="min-w-0">
                  <h1 className={`text-xs sm:text-sm font-bold transition-colors duration-300 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>KYC Verification</h1>
                  <p className={`text-[8px] sm:text-[9px] transition-colors duration-300 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`}>Verify customer documents for KYC compliance</p>
                </div>
              </div>
            </div>

            {/* Search & Button - Fixed */}
            <div className="flex-shrink-0 mb-3">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search by Aadhaar..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className={`w-full pl-8 pr-3 py-2 text-[10px] rounded-xl border focus:outline-none transition-all duration-300 ${isDarkMode
                        ? 'border-white/10 bg-white/[0.03] text-white placeholder-gray-500 focus:border-indigo-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-indigo-500/20'
                        : 'border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500'
                      }`}
                  />
                  <Search className={`absolute left-2.5 top-1/2 transform -translate-y-1/2 w-3.5 h-3.5 ${isDarkMode ? 'text-indigo-400' : 'text-blue-600'}`} />
                </div>

                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search by Name..."
                    value={searchQueryByName}
                    onChange={handleSearchChangeByName}
                    className={`w-full pl-8 pr-3 py-2 text-[10px] rounded-xl border focus:outline-none transition-all duration-300 ${isDarkMode
                        ? 'border-white/10 bg-white/[0.03] text-white placeholder-gray-500 focus:border-indigo-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-indigo-500/20'
                        : 'border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500'
                      }`}
                  />
                  <Search className={`absolute left-2.5 top-1/2 transform -translate-y-1/2 w-3.5 h-3.5 ${isDarkMode ? 'text-indigo-400' : 'text-blue-600'}`} />
                </div>

                <button
                  className={`w-full py-2 px-3 rounded-xl border text-[10px] font-semibold transition-all duration-300 flex items-center justify-center gap-1.5 sm:col-span-2 md:col-span-1 ${isDarkMode
                      ? 'border-indigo-500/40 bg-indigo-500/[0.08] text-indigo-300 hover:bg-indigo-500/15 hover:shadow-[0_0_15px_rgba(99,102,241,0.3)]'
                      : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                  onClick={goTobankReq}
                >
                  <Building size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} /> Bank Document Requests
                </button>
              </div>
            </div>

            {/* Cards Grid - Scrollable */}
            <div className="flex-1 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 sm:gap-3 pb-3">
                {(searchQuery.trim().length === 12 && filteredCustomers.length === 0) ? (
                  <div className={`col-span-full text-center text-[11px] py-8 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                    No customers found with this Aadhaar number.
                  </div>
                ) : (
                  (searchQueryByName.trim().length > 0 && filteredCustomers.length === 0) ? (
                    <div className={`col-span-full text-center text-[11px] py-8 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                      No customers found with this Name.
                    </div>
                  ) : (
                    (filteredCustomers.length > 0 ? filteredCustomers : customers).map((customer) => (
                      <div
                        key={customer.id}
                        className={`rounded-2xl overflow-hidden p-3 flex flex-col transition-all duration-300 ${isDarkMode
                            ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border border-gray-800 hover:border-indigo-500/40 hover:shadow-[0_0_25px_rgba(99,102,241,0.15)]'
                            : 'bg-white border border-gray-200 shadow-sm hover:shadow-md'
                          }`}
                      >

                        {/* Header */}
                        <div className={`border-b pb-2 mb-2 flex justify-between items-center gap-2 ${isDarkMode ? 'border-gray-800' : 'border-gray-100'}`}>
                          <h2 className={`text-[11px] font-bold flex items-center gap-1.5 truncate min-w-0 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                            <User size={13} className={`flex-shrink-0 ${isDarkMode ? 'text-indigo-400' : 'text-blue-500'}`} />
                            <span className="truncate">{customer.name}</span>
                          </h2>
                          <div className="flex items-center gap-1.5 flex-shrink-0">
                            <button
                              className={`p-1.5 rounded-lg border transition-all duration-200 ${isDarkMode
                                  ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_8px_rgba(99,102,241,0.4)]'
                                  : 'border-transparent hover:bg-gray-100'
                                }`}
                              onClick={() => handleClick(customer)}
                            >
                              <FaEye size={13} />
                            </button>
                            <button
                              className={`p-1.5 rounded-lg border transition-all duration-200 ${isDarkMode
                                  ? 'border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:shadow-[0_0_8px_rgba(244,63,94,0.4)]'
                                  : 'border-transparent hover:bg-gray-100'
                                }`}
                              onClick={() => handleDelete(customer)}
                            >
                              <MdDeleteForever size={14} />
                            </button>
                          </div>
                        </div>

                        {/* Company */}
                        <div className="flex items-center gap-1.5 mb-2">
                          <Building size={13} className={`flex-shrink-0 ${isDarkMode ? 'text-emerald-400' : 'text-green-500'}`} />
                          <span className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Company:</span>
                          <span className={`text-[9px] truncate ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>{customer.company_type || 'N/A'}</span>
                        </div>

                        {/* ID Info - Grid */}
                        <div className={`rounded-xl p-2 mb-2 transition-colors duration-300 ${isDarkMode
                            ? 'bg-[#0F172A]/60 border border-gray-800'
                            : 'bg-gray-50'
                          }`}>
                          <div className="flex items-center gap-1.5 mb-1.5">
                            <CreditCard size={13} className={isDarkMode ? 'text-indigo-400' : 'text-blue-500'} />
                            <span className={`text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-indigo-300' : 'text-gray-500'}`}>ID Details</span>
                          </div>
                          <div className="grid grid-cols-3 gap-1.5 sm:gap-2">
                            <div className={`rounded px-1.5 py-1 border transition-colors duration-300 min-w-0 ${isDarkMode
                                ? 'bg-[#111827] border-gray-800'
                                : 'bg-white border-gray-200'
                              }`}>
                              <div className={`text-[8px] uppercase tracking-wider ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>GST</div>
                              <div className={`text-[9px] font-mono truncate ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{customer.gst_number || 'N/A'}</div>
                            </div>
                            <div className={`rounded px-1.5 py-1 border transition-colors duration-300 min-w-0 ${isDarkMode
                                ? 'bg-[#111827] border-gray-800'
                                : 'bg-white border-gray-200'
                              }`}>
                              <div className={`text-[8px] uppercase tracking-wider ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Aadhaar</div>
                              <div className={`text-[9px] font-mono truncate ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{customer.aadhar_number || 'N/A'}</div>
                            </div>
                            <div className={`rounded px-1.5 py-1 border transition-colors duration-300 min-w-0 ${isDarkMode
                                ? 'bg-[#111827] border-gray-800'
                                : 'bg-white border-gray-200'
                              }`}>
                              <div className={`text-[8px] uppercase tracking-wider ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>PAN</div>
                              <div className={`text-[9px] font-mono truncate ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{customer.pancard_number || 'N/A'}</div>
                            </div>
                          </div>
                        </div>

                        {/* Documents */}
                        <div className="space-y-1 mb-2">
                          <div className="flex items-center gap-1.5 mb-0.5">
                            <FileText size={13} className={isDarkMode ? 'text-purple-400' : 'text-blue-500'} />
                            <span className={`text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-purple-300' : 'text-gray-500'}`}>Documents</span>
                          </div>
                          {customer.user_address_image && (
                            <div className={`flex items-center justify-between py-1 px-2 rounded-lg gap-2 transition-colors duration-150 ${isDarkMode ? 'hover:bg-[#1F2937]/60' : 'hover:bg-gray-50'
                              }`}>
                              <span className={`text-[9px] flex-shrink-0 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Aadhaar</span>
                              <div className="flex items-center gap-2 flex-wrap justify-end min-w-0">
                                <button
                                  className={`text-[9px] underline transition-colors flex-shrink-0 ${isDarkMode
                                      ? 'text-indigo-400 hover:text-indigo-300'
                                      : 'text-gray-500 hover:text-gray-800'
                                    }`}
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_address_image)}
                                >
                                  View
                                </button>
                                {docStatusBlock(customer.aadhar_status, customer.id, 'address')}
                              </div>
                            </div>
                          )}
                          {customer.user_pancard_image && (
                            <div className={`flex items-center justify-between py-1 px-2 rounded-lg gap-2 transition-colors duration-150 ${isDarkMode ? 'hover:bg-[#1F2937]/60' : 'hover:bg-gray-50'
                              }`}>
                              <span className={`text-[9px] flex-shrink-0 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>PAN</span>
                              <div className="flex items-center gap-2 flex-wrap justify-end min-w-0">
                                <button
                                  className={`text-[9px] underline transition-colors flex-shrink-0 ${isDarkMode
                                      ? 'text-indigo-400 hover:text-indigo-300'
                                      : 'text-gray-500 hover:text-gray-800'
                                    }`}
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_pancard_image)}
                                >
                                  View
                                </button>
                                {docStatusBlock(customer.pan_card_status, customer.id, 'pancard')}
                              </div>
                            </div>
                          )}
                          {customer.user_gst_image && (
                            <div className={`flex items-center justify-between py-1 px-2 rounded-lg gap-2 transition-colors duration-150 ${isDarkMode ? 'hover:bg-[#1F2937]/60' : 'hover:bg-gray-50'
                              }`}>
                              <span className={`text-[9px] flex-shrink-0 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>GST</span>
                              <div className="flex items-center gap-2 flex-wrap justify-end min-w-0">
                                <button
                                  className={`text-[9px] underline transition-colors flex-shrink-0 ${isDarkMode
                                      ? 'text-indigo-400 hover:text-indigo-300'
                                      : 'text-gray-500 hover:text-gray-800'
                                    }`}
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_gst_image)}
                                >
                                  View
                                </button>
                                {docStatusBlock(customer.gst_status, customer.id, 'gstin')}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Submit Button */}
                        <div className={`mt-auto pt-2 border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-100'}`}>
                          {customer.aadhar_status === "1" &&
                            customer.pan_card_status === "1" &&
                            customer.gst_status === "1" ? (
                            <div className={`text-center py-1.5 text-[10px] font-semibold rounded-lg border flex items-center justify-center gap-1.5 ${isDarkMode
                                ? 'text-emerald-300 border-emerald-500/40 bg-emerald-500/10 shadow-[0_0_15px_rgba(16,185,129,0.2)]'
                                : 'text-white border-green-200 bg-emerald-500'
                              }`}>
                              <CheckCircle size={12} /> Verified
                            </div>
                          ) : customer.aadhar_status === "2" &&
                            customer.pan_card_status === "2" &&
                            customer.gst_status === "2" ? (
                            <div className={`text-center py-1.5 text-[10px] font-semibold rounded-lg border flex items-center justify-center gap-1.5 ${isDarkMode
                                ? 'text-rose-300 border-rose-500/40 bg-rose-500/5'
                                : 'text-gray-500 border-gray-200'
                              }`}>
                              <XCircle size={12} /> Rejected
                            </div>
                          ) : !customer.user_address_image &&
                            !customer.user_pancard_image &&
                            !customer.user_gst_image ? (
                            <div className={`text-center py-1.5 text-[9px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                              Upload documents to verify
                            </div>
                          ) : shouldShowSubmitButton(customer) ? (
                            <button
                              className={`w-full py-1.5 text-[10px] font-semibold rounded-lg transition-all duration-300 ${isDarkMode
                                  ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-[0_0_20px_rgba(99,102,241,0.5)]'
                                  : 'bg-gray-800 text-white hover:opacity-80'
                                } disabled:opacity-50 disabled:cursor-not-allowed`}
                              onClick={() => handleSubmit(customer.id)}
                              disabled={loading[customer.id]}
                            >
                              {loading[customer.id] ? "Submitting..." : "Submit"}
                            </button>
                          ) : (
                            <div className={`text-center py-1.5 text-[9px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                              Select status to submit
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )
                )}
              </div>
            </div>

            {/* Pagination - Fixed */}
            <div className={`flex-shrink-0 mt-3 pt-3 border-t flex flex-col sm:flex-row justify-between items-center gap-2 transition-colors duration-300 ${isDarkMode ? 'border-gray-800' : 'border-gray-200'
              }`}>
              <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Total: <span className={`font-bold ${isDarkMode ? 'text-indigo-300' : 'text-gray-800'}`}>{totalCustomers}</span> customers
              </span>
              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`border rounded-lg p-1 text-[9px] focus:outline-none transition-colors duration-300 ${isDarkMode
                      ? 'border-gray-700 bg-[#1F2937] text-gray-200 focus:ring-1 focus:ring-indigo-500'
                      : 'border-gray-300 bg-white text-gray-800 focus:ring-1 focus:ring-gray-500'
                    }`}
                >
                  {totalCustomers === 0 ? (
                    <option value={0}>0</option>
                  ) : (
                    <>
                      {totalCustomers >= 10 && <option value={10}>10</option>}
                      {totalCustomers >= 15 && <option value={15}>15</option>}
                      {totalCustomers >= 20 && <option value={20}>20</option>}
                      {totalCustomers > 30 && <option value={totalCustomers}>All</option>}
                    </>
                  )}
                </select>
                <Pagination
                  count={Math.ceil(totalCustomers / limit)}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      color: isDarkMode ? '#E5E7EB' : '#374151',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.2)' : '#428475',
                        color: isDarkMode ? '#a5b4fc' : '#fff',
                        borderColor: isDarkMode ? '#6366f1' : '#000',
                        boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.4)' : 'none',
                      },
                      '&:hover': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.1)' : '#F3F4F6',
                      }
                    },
                  }}
                />
              </div>
            </div>

            <ViewAllCustomerModel isopen={isPopupOpen} onClose={handleClose} customer={selectedCustomer} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYCPending;